import React from "react";

import styled from "@emotion/styled";
import { Link } from "react-router-dom";

import ROUTES from "manager/config/routes";
import { colors } from "shared/config/constants/app.theme";

const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 20px;
  background: #faf8ff;
  border: 1px solid ${colors.secondary[200]};
  border-radius: 8px;
  margin-bottom: 16px;
`;

const LeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const StatusDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #059669;
  flex-shrink: 0;
`;

const StatusLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.primary[400]};
  white-space: nowrap;
`;

const Divider = styled.span`
  width: 1px;
  height: 16px;
  background: ${colors.secondary[200]};
  flex-shrink: 0;
`;

const Description = styled.span`
  font-size: 13px;
  line-height: 1.4;
  color: ${colors.primary[200]};
`;

const SettingsLink = styled(Link)`
  font-size: 13px;
  font-weight: 500;
  color: ${colors.secondary[500]};
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  &:hover {
    color: ${colors.secondary[600]};
    text-decoration: underline;
  }
`;

interface VeroGoBannerProps {
  show: boolean;
  message?: string;
}

const VeroGoBanner = ({ show, message }: VeroGoBannerProps) => {
  if (!show) return null;
  return (
    <BannerWrapper>
      <LeftContent>
        <StatusDot />
        <StatusLabel>Vero Go Enabled</StatusLabel>
        <Divider />
        <Description>
          {message ||
            "Applicants are screened using identity verification and document-based income verification only."}
        </Description>
      </LeftContent>
      <SettingsLink to={ROUTES.veroGoSettings}>View Settings</SettingsLink>
    </BannerWrapper>
  );
};

export default VeroGoBanner;
